import { Input } from "antd";

// Input de código de un solo uso (6 dígitos por defecto).
// - Filtra a solo dígitos.
// - Si se le pasa `onComplete`, lo llama automáticamente al rellenar la última casilla.
export default function OtpCodeInput({
  value,
  onChange,
  onComplete,
  length = 6,
  autoFocus = false,
  disabled = false,
}) {
  return (
    <Input.OTP
      length={length}
      value={value}
      autoFocus={autoFocus}
      disabled={disabled}
      formatter={(str) => str.replace(/\D/g, "")}
      onChange={(val) => {
        onChange?.(val);
        if (val && val.length === length) onComplete?.(val);
      }}
    />
  );
}
